module.exports = __webpack_public_path__ + "static/media/avatar.ce54dd20.jpg";